import { Avatar, Button, Container, Grid, Input, Paper, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import useStyles from './styles';
import LockOutLinedIcon from '@material-ui/icons/LockOutlined';

const SignIn = () => {
    const classes = useStyles();
    const [isSignUp, setisSignUp] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const switchMode = () => {
        setisSignUp((prev) => !prev);
        setShowPassword(false);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
    };
    const handleChange = (e) => {

    };
    const handleShowPassword = () => setShowPassword((prev) => !prev);

    return (
        <Container component="main" maxWidth="xs">
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutLinedIcon />
                </Avatar>
                <Typography variant='h5'>
                    {
                        isSignUp ? 'Sign Up' : 'Sign In'
                    }
                </Typography>
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        {
                            isSignUp && (
                                <>
                                    <Input name="firstName" label="First Name" /*handleChange={handleChange}*/ autoFocus half />
                                    <Input name="LastName" label="Last Name" /*handleChange={handleChange}*/ half />
                                </>
                            )
                        }
                        <Input name="email" label="Email Address" /*handleChange={handleChange}*/ type="email" />
                        <Input name="password" label="Password" /*handleChange={handleChange}*/ type={showPassword ? "text" : "password"} /*handleShowPassword={handleShowPassword}*/ />
                        {
                            isSignUp && <Input name="confirmPassword" label="Confirm Password" /*handleChange={handleChange}*/ type="password" />
                        }
                    </Grid>
                    <Button type="submit" fullWidth variant='contained' color="primary" className={classes.submit}>
                        {
                            isSignUp ? 'Sign Up' : 'Sign In'
                        }
                    </Button>

                    <Grid container justifyContent='flex-end'>
                        <Grid item>
                            <Button onClick={switchMode}>
                                {
                                    isSignUp ? 'Already have an account? Sign In' : "Don't have an account Sign Up"
                                }
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </Container>
    )
}

export default SignIn